// components/settings/settingsUtils.js — Anamoria SPA
// v1.2 — NEW-26 support, plus two latent bugs in these helpers:
//   - getStatusKey collapsed 'revoked' into 'pending', which made
//     ContributorsPanel's `key === 'revoked'` branch unreachable. Revoked
//     rows have therefore rendered with the PENDING badge since v1.1, even
//     though .statusRevoked exists in that CSS module.
//   - getStatusLabel checked for 'invited', but the DB status is 'pending',
//     so it fell through and returned the raw lowercase string.
//   ContributorsPanel is the only consumer of these two helpers;
//   SpaceSettings.jsx and SuggestionsPanel.jsx define their own local copies.
// v1.1 — Add imagePath to theme options for screenshot thumbnails (April 21, 2026)
//
// Changes from v1.0:
//   - THEME_OPTIONS: added imagePath field pointing to cropped card screenshots
//     in public/images/themes/. Replaces CSS-drawn abstract previews in
//     SpaceInfoPanel theme picker with real card images.
//   - previewLabel retained for backward compatibility (not currently rendered).
//
// v1.0 — Shared constants and helpers for settings panels (April 11, 2026)
//
// Extracted from SpaceSettings.jsx v1.1 to avoid duplication across
// SpaceInfoPanel, ContributorsPanel, RemindersPanel, NeedHelpPanel.
// Pure functions and constants only — no React, no styles, no side effects.

/* ─── Day options for reminder day selector ─── */

export const DAY_OPTIONS = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

/* ─── Voice card theme options for theme picker ─── */

export const THEME_OPTIONS = [
  { value: 'warm', label: 'Warm', previewLabel: '● VOICE', imagePath: '/images/themes/voice-card-warm.png' },
  { value: 'story', label: 'Story', previewLabel: '❙❙', imagePath: '/images/themes/voice-card-story.png' },
  { value: 'sage', label: 'Sage', previewLabel: '🎙', imagePath: '/images/themes/voice-card-sage.png' },
  { value: 'clean', label: 'Clean', previewLabel: '▌▌▌▌', imagePath: '/images/themes/voice-card-clean.png' },
];

/* ─── Contributor status helpers ─── */

/**
 * Returns a status key string for CSS class lookup.
 * The consuming component maps this to its own CSS module class.
 *   'active'  → styles.statusActive
 *   'revoked' → styles.statusRevoked
 *   'pending' → styles.statusPending
 */
export function getStatusKey(status) {
  if (status === 'active') return 'active';
  if (status === 'revoked') return 'revoked';
  return 'pending';
}

/**
 * Returns a human-readable label for contributor status.
 */
export function getStatusLabel(status) {
  if (status === 'active') return 'Active';
  if (status === 'invited' || status === 'pending') return 'Pending';
  if (status === 'revoked') return 'Revoked';
  return status || 'Pending';
}

/**
 * Returns a human-readable label for memory count.
 */
export function getMemoryLabel(count) {
  if (count === 1) return '1 memory';
  return `${count || 0} memories`;
}
